import { render, staticRenderFns } from "./SelectDefect.vue?vue&type=template&id=4ccad9c8&scoped=true&"
import script from "./SelectDefect.vue?vue&type=script&lang=js&"
export * from "./SelectDefect.vue?vue&type=script&lang=js&"
import style0 from "./SelectDefect.vue?vue&type=style&index=0&id=4ccad9c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccad9c8",
  null
  
)

export default component.exports